import { useCallback } from 'react';
import { useFetch } from './use-fetch';
import type { ServiceAvailabilityResponse } from '../models/repair-bookings.ts';
import { fetchAvailability } from '../utils/api.ts';

const useServiceAvailability = (defaultMessages?: string[]) => {
    const fetcher = useCallback((): Promise<ServiceAvailabilityResponse> => {
        const csrfToken = window.preloadedState.environment.csrfToken;
        return fetchAvailability(csrfToken);
    }, []);

    const { data, error, loading } = useFetch(fetcher);

    return {
        available: !loading && data && data.available,
        messages: loading
            ? ['']
            : error
              ? ['情報の取得に失敗しました (' + error.message + ')']
              : data?.messages?.length
                ? data.messages
                : defaultMessages || ['お知らせは現在ございません'],
    };
};

export default useServiceAvailability;
